import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class AppConfigService {
	private config: any = {};

	constructor(@Inject(DOCUMENT) private document: Document) {}

	loadConfig() {
		// obter o hostname da URL atual
		const hostname = window.location.hostname;

		if (hostname.includes("whatsauto")) {
			this.config = {
				...environment.whatsAutoConfig,
			};
		} else if (hostname.includes("whatsparts")) {
			this.config = {
				...environment.whatsPartsConfig,
			};
		} else {
			this.config = {
				...environment.whatsAutoConfig,
			};
		}

		// Carregar o arquivo de estilos correspondente
		this.loadStyle(this.config.stylePath);
	}

	loadStyle(stylePath: string) {
		const linkElement = this.document.createElement("link");
		linkElement.rel = "stylesheet";
		linkElement.href = stylePath;
		this.document.head.appendChild(linkElement);
	}

	get(key: string): any {
		return this.config[key];
	}

	getAll(): any {
		return this.config;
	}
}
